import { Injectable, Injector } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { ProfissionalRecursoModel } from '../../../equipe/domain/models';
import { SelectDto } from 'projects/ProjetoBaseAngular/domain/models/select-dto';
import { ProfissionalRecursoSelectDto } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ProfissionalRecursoService extends BaseCrudService<ProfissionalRecursoModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'ProfissionalRecurso';
  }

  getSelectList(): Observable<ProfissionalRecursoSelectDto[]> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetSelectList`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }

  getSelectListUser(): Observable<SelectDto[]> {
    return this
      .httpClient
      .get(`${this.getApiUrl()}${this.getController()}/GetSelectListUser`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
